<template>
  <Breadcrumbs
      title="Distributor Wise Sales Report"
      :breadcrumbs="[
      { label: 'Sales', path: '' },
      { label: 'Invoices', path: '/invoice' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <invoiceForm/>
    </div>
  </div>
</template>

<script>
import invoiceForm from './distributorsalesreport_form.vue'
export default {
  name: 'indexList',
  components: {
    invoiceForm,
  },
}
</script>
